import { ClientType } from "../enums/clientTypeEnum";

export interface OrderType{
    id: string;
    createdAt: string;
    updatedAt: string | null;
    deletedAt: string | null;
    name: string;
    discount: number | null;
    clientType: ClientType
}

export const defaultOrderType: OrderType = {
    id: "",
    createdAt: "",
    updatedAt: null,
    deletedAt: null,
    name: "",
    discount: null,
    clientType: ClientType.Standard
};